<template>
    <form class="mt-5">
        <div class="row">
            <div class="col-md-6 mt-5">
                <h2>Factuuradres</h2>
                <div class="form-group">
                    <label class="label" for="invoiceDepartment">Afdeling</label>
                    <div class="control" >
                        <input :class="['form-control']" type="text" placeholder="Afdeling" v-model="form.invoiceDepartment" name="invoiceDepartment" id="invoiceDepartment" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Afdeling is verplicht met minimaal 2 karakters.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="invoiceAddress">Straat + Huisnummer <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.invoiceAddress.$dirty) ? ($v.form.invoiceAddress.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Straat + Huisnummer" v-model="form.invoiceAddress" name="invoiceAddress" id="invoiceAddress"  @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Adres is verplicht. Het adres moet een straatnaam en huisnummer bevatten.
                        </div>
                    </div>
                </div>
                <div class="form-group" for="invoicePostalCode">
                    <label class="label">Postcode <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.invoicePostalCode.$dirty) ? ($v.form.invoicePostalCode.$error) ?'is-invalid' : 'is-valid' : '']"  type="text" placeholder="1234 XX" v-model.trim="form.invoicePostalCode" name="invoicePostalCode" id="invoicePostalCode"  @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Postcode is verplicht. Postcode moet het formaat 1234 XX hebben.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="invoiceCity">Plaats <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <v-select label="name" :filterable="false" :options="$store.getters.cities" @search="onSearchCity" v-model="form.invoiceCity" :class="['form-control', ($v.form.invoiceCity.$dirty) ? ($v.form.invoiceCity.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Plaats" name="invoiceCity" id="invoiceCity" @change="$v.form.invoiceCity.$touch">
                            <template slot="no-options">
                                Zoek een plaats...
                            </template>
                            <template slot="option" slot-scope="option" class="m-0 p-0">
                                <div class="d-center m-0 p-0" >
                                    {{ option.name }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.name }}
                                </div>
                            </template>
                        </v-select>
                        <div class="invalid-feedback">
                            Plaatsnaam is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="invoicePhone">Facturatie Telefoonnummer <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.invoicePhone.$dirty) ? ($v.form.invoicePhone.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="Facturatie Telefoonnummer" v-model.trim="form.invoicePhone" name="invoicePhone" id="invoicePhone"  @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Telefoonnummer is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="invoiceEmail">Facturatie Emailadres <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.invoiceEmail.$dirty) ? ($v.form.invoiceEmail.$error) ?'is-invalid' : 'is-valid' : '']" type="email" placeholder="Facturatie Emailadres" v-model.trim="form.invoiceEmail" name="invoiceEmail" id="invoiceEmail"  @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Email is verplicht.
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-md-6 mt-5">
                <h2>IBAN Bankrekening</h2>
                <iban @update="updateIban" @valid="validateIban" :account="form.invoiceIBAN"></iban>
                
                <div class="form-group">
                    <label for="invoiceBankAccountName" class="form-label">Ten name van:</label>
                    <input :class="['form-control', ($v.form.invoiceBankAccountName.$dirty) ? ($v.form.invoiceBankAccountName.$error) ?'is-invalid' : 'is-valid' : '']" id="invoiceBankAccountName" name="invoiceBankAccountName" placeholder="Ten name van" v-model="form.invoiceBankAccountName" @change="$v.form.invoiceBankAccountName.$touch" /> 
                    <div class="invalid-feedback">
                        Verplicht!
                    </div>
                    <small>Er wordt niets afgeschreven. Het rekeningnummer wordt gebruikt voor het verifieren van de facturatie.</small>
                </div>

                <h2 class="mt-4">Jaarverslag</h2>
                <div class="form-group">
                    <label>Recent Jaarverslag</label>
                    <div class="input-group">
                        <div class="custom-file">
                            <input type="file" id="vogFile" :class="['custom-file-input form-control', ($v.form.annualReport.$dirty) ? ($v.form.annualReport.$error) ? 'is-invalid' : 'is-valid' : '']" @change="setUploadFile('annualReport', $event)">
                            <label class="custom-file-label" for="vogFile">{{form.annualReportName}}</label>
                        </div>
                    </div>
                    <small>Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.</small>
                </div>
                
                <h2 class="mt-4">Kamer van Koophandel</h2>
                <div class="form-group">
                    <label>Kamer van Koophandel <sup class="red" title="verplicht">*</sup></label>
                    <div class="input-group">
                        <div class="custom-file">
                            <input type="file" id="vogFile" :class="['custom-file-input form-control', ($v.form.kvkDocument.$dirty) ? ($v.form.kvkDocument.$error) ? 'is-invalid' : 'is-valid' : '']" @change="setUploadFile('kvkDocument', $event)">
                            <label class="custom-file-label" for="vogFile">{{form.kvkDocumentName}}</label>
                        </div>
                    </div>
                    <small><strong>Verplicht!</strong> Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.</small>
                </div>
            </div>

        </div>
    </form>
</template>

<script>
import vSelect from 'vue-select';
import { validationMixin } from 'vuelidate'
import globalFunctions from '@/mixins/globalFunctions'
import { required, minLength, maxLength, helpers, email, or } from 'vuelidate/lib/validators'
import IBAN from '@/components/IBAN'

const postalcode = helpers.regex('postalcode', /^[1-9][0-9]{3} ?[A-Z]{2}$/);    
const address = helpers.regex('address', /^([1-9][e][\s])*([a-zA-Z]+(([.][\s])|([\s]))?)+[1-9][0-9]*(([-][1-9][0-9]*)|([\s]?[a-zA-Z]+))?$/);
const mobile = helpers.regex('mobile', /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7}|((\\+31|0|0031)6)[-]{1}[1-9]{1}[0-9]{7})$/);
const landline = helpers.regex('landline', /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/);
const fileValidation = (value) => 
{
    if(value != null)
    {
        const ext = value.name.split(".")[value.name.split(".").length - 1];
        const extentions = ['doc', 'docx', 'pdf', 'jpg', 'png', 'jpeg'];
        return value.size <= 4000000 && extentions.indexOf(ext) >= 0;
    }
    return true;
}

    export default {
        props: ['clickedNext', 'currentStep'],
        mixins: [validationMixin, globalFunctions],
        components: {
            iban: IBAN,
            vSelect
        },
        data() {
            return {
                isLoading: false,
                ibanValid: false,
                form: {
                    invoiceDepartment: '',
                    invoiceEmail: '',
                    invoicePhone: '',
                    invoiceAddress: '',
                    invoicePostalCode: '',
                    invoiceCity: '',
                    invoiceIBAN: '',
                    invoiceBankAccountName: '',
                    annualReport: null,
                    annualReportName: 'Kies een document...',
                    kvkDocument: null,
                    kvkDocumentName: 'Kies een document...'
                },
            }
        },
        validations: {
            form: {
                invoicePhone: {
                    required,
                    or: or(landline, mobile)
                },
                invoiceEmail: {
                    required,
                    email
                },
                invoiceAddress: {
                    required,
                    maxLength: maxLength(100),
                    address
                },
                invoicePostalCode: {
                    required,
                    minLength: minLength(6),
                    maxLength: maxLength(7),
                    postalcode
                },
                invoiceCity: {
                    required
                }, 
                invoiceBankAccountName: {
                    
                },
                /*
                invoiceIBAN: {
                    required,
                    iban
                },
                */
                annualReport:
                {
                    fileValidation
                },
                kvkDocument: 
                {
                    required,
                    fileValidation
                }
            },
        },
        methods: {  
            onSearchCity(search, loading) {
                this.$store.dispatch('GET_CITIES', { search, loading });
            }, 
            validateIban(valid)
            {
                this.ibanValid = valid;
                if(!this.$v.$invalid && valid) {
                    this.$emit('can-continue', {value: true});
                } else {
                    this.$emit('can-continue', {value: false});
                }
            }, 
            updateIban(iban)
            {
                this.form.invoiceIBAN = iban;
            },
            setUploadFile(doc, ev) {
                this.form[doc] = ev.currentTarget.files[0];
                this.$v.form[doc].$touch();
                if(this.form[doc] != null)
                    return this.form[doc + 'Name'] = this.form[doc].name;
                return this.form[doc + 'Name'] = 'Kies een document...';
            },
            getProfile() {
                this.isLoading = true;
                return this.$http.get('api/Profile/Client/Wizard/2').then((res) => 
                {
                    this.form.invoiceDepartment = res.data.invoiceDepartment;
                    this.form.invoiceEmail = res.data.invoiceEmail;
                    this.form.invoicePhone = res.data.invoicePhone;
                    this.form.invoiceAddress = res.data.invoiceAddress;
                    this.form.invoicePostalCode = res.data.invoicePostalCode;
                    this.form.invoiceCity = res.data.invoiceCity;

                    this.form.invoiceIBAN = res.data.invoiceIBAN;
                    this.form.invoiceBankAccountName = res.data.invoiceBankAccountName;

                    this.form.annualReportName = res.data.annualReportName;
                    if(res.data.annualReportName.indexOf("Kies een") < 0)
                        this.form.annualReport = this.b64ToFile(res.data.annualReport, '', res.data.annualReportName);

                    this.form.kvkDocumentName = res.data.kvkDocumentName;
                    if(res.data.kvkDocumentName.indexOf("Kies een") < 0)
                        this.form.kvkDocument = this.b64ToFile(res.data.kvkDocument, '', res.data.kvkDocumentName);

                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                })
            },
            setProfile() {
                return new Promise((resolve, reject) => {
                    this.isLoading = true;
                    var formData = new FormData();

                    for ( var key in this.form) {
                        formData.append(key, this.form[key]);
                    }
                    
                    return this.$http.post('api/Profile/Client/Wizard/2', formData).then(() => {
                        this.isLoading = false;
                        return resolve();
                    }).catch((res) => {
                        this.isLoading = false;
                        return reject(res);
                        //alert('Oops, de vorige stap is niet goed opgeslagen!')
                    })
                });
            }
        },
        watch: {
            $v: {
                handler: function (val) {
                    this.$v.form.$touch();
                    if(!val.$invalid) {
                        this.$emit('can-continue', {value: true});
                    } else {
                        this.$emit('can-continue', {value: false});
                    }
                },
                deep: true
            },
            clickedNext(val) {
                if(val === true) {
                    this.$v.form.$touch();
                }
            }
        },
        mounted() {
            this.getProfile().then(() => {
                if(!this.$v.$invalid) {
                    this.$emit('can-continue', {value: true});
                } else {
                    this.$emit('can-continue', {value: false});
                }
            });
        }
    }
</script>

<style >
label.custom-file-label {
    display: inline-block !important;
}


</style>